export const TERMS_AND_CONDITIONS_LINK = 'https://openai.com/terms/';
export const USER_HAS_SEEN_THE_OPENAI_TERMS = 'userHasSeenTheOpenAITerms';
